
		<info-modal [title]="title" (onOk)="ok()">
			<loading [isLoad]="!stats"></loading>
			
			<div class="row">
				<div class="col-md-4">
					<chart [data]="chart.data" [options]="chart.options" [sextant]="'chart'"></chart>
				</div>
	
				<div class="col-md-8">
					<div class="form-group">
						{{ 'adminstat.mails.mailer.date filter' | translate }}
						<select class="form-control" [(ngModel)]="type" [ngModelOptions]="{standalone: true}">
							<option *ngFor="let val of ['all', 'now', 'yesterday', 'prevWeek', 'prevMonth', 'last7day', 'last30day', 'other']"
									value="{{ val }}" [selected]="val == dateFilter">
								{{ 'adminstat.common.interval.' + val | translate }}
							</option>
						</select>
	
						<table>
							<tr [style.display]="type != 'other' ? 'none' : null">
								<td>
									<datepicker [(ngModel)]="start" [ngModelOptions]="{standalone: true}" [format]="'DD-MM-YYYY'"></datepicker>
									<datepicker [(ngModel)]="end" [ngModelOptions]="{standalone: true}" [format]="'DD-MM-YYYY'"></datepicker>
								</td>
							</tr>
						</table>
	
						<br><br>
	
						<button type="button" class="btn btn-success" (click)="applyFilters()" [sextant]="'btnApplyFilters'">{{ 'adminstat.common.Apply' | translate }}</button>
						<button type="button" class="btn btn-link" style="color:red;" (click)="resetFilters()">{{ 'adminstat.common.Reset filters' | translate }}</button>

						<button type="button" class="btn btn-warning" (click)="downloadTopSites()" style="float:right;">{{ 'adminstat.support.accessor.export csv top sites' | translate }}</button>
					</div>
	
					<br><br>
	
					<table class="table" *ngIf="stats && stats.length > 0">
						<thead>
							<th>{{ 'adminstat.support.accessor.accessor' | translate }}</th>
							<th>{{ 'adminstat.support.accessor.categorized' | translate }}</th>
							<th>{{ 'adminstat.support.accessor.defered' | translate }}</th>
							<th>{{ 'adminstat.support.accessor.viewed' | translate }}</th>
						</thead>
	
						<tbody>
							<tr *ngFor="let stat of stats">
								<td>
									{{ stat.email }}
								</td>
		
								<td>
									{{ stat.setCategoryCount }}
								</td>
		
								<td>
									{{ stat.deferCount }}
								</td>
		
								<td>
									{{ stat.totalCount }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</info-modal>
	